export default {
  title: "自动回复",
  addLabel: "新增标签",
  label: "标签",
  sort: "排序",
  addAutoReply: "新增自动回复",
  selectTags: "请选择标签",
  message: {
    label: "请先添加标签",
    uploadImg: "请上传图片",
  },
  form: {
    addReply: "新增回复",
    addImg: "新增图片",
    serial: "发送序号",
  },
};
